import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("run_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Build absolute URL for a backend view path like "/api/files/...".
export const absUrl = (viewPath, withToken = false) => {
  if (!viewPath) return "";
  let url = `${BACKEND_URL}${viewPath}`;
  if (withToken) {
    const token = localStorage.getItem("run_token");
    if (token) url += `${viewPath.includes("?") ? "&" : "?"}auth=${token}`;
  }
  return url;
};
